export default __webpack_public_path__ + "static/media/Miasmacies.1e59c942.jpg";